import { useEffect, useState } from "react";
import { updatePortfolioFields } from "@/services/portfolio/PortfolioService";
import { usePortfolioAllocations } from "./usePortfolioAllocations";

export const usePortfolioData = (portfolioId: string | undefined) => {
  const [portfolioSize, setPortfolioSize] = useState(100000);
  const [portfolioName, setPortfolioName] = useState("");

  const { data: portfolio, isLoading, refetch, error } = usePortfolioAllocations(portfolioId);

  // Sync state when portfolio data changes
  useEffect(() => {
    if (portfolio && !portfolioName) {
      // Only set if we don't have a portfolio name yet (avoid overwriting user edits)
      setPortfolioName(portfolio.name || "");
    }

    if (portfolio?.portfolio_size !== undefined && portfolio.portfolio_size !== null) {
      setPortfolioSize(portfolio.portfolio_size);
    }
  }, [portfolio, portfolioName]);

  const updatePortfolioSize = async (newSize: number) => {
    setPortfolioSize(newSize);

    if (portfolioId) {
      try {
        await updatePortfolioFields(portfolioId, { portfolio_size: newSize });
        return true;
      } catch (error) {
        console.error('Error updating portfolio size:', error);
        return false;
      }
    }
    return true;
  };

  const handlePortfolioSizeChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    const newSize = Number(value) || 0;
    setPortfolioSize(newSize);
  };

  return {
    portfolio,
    isLoading,
    refetch,
    portfolioSize,
    setPortfolioSize,
    portfolioName,
    setPortfolioName,
    handlePortfolioSizeChange,
    updatePortfolioSize,
    error,
  };
};
